/**
 * ADM-131 / MEV-531 — cross-cutting auth session events.
 *
 * The API client (axios interceptor) dispatches `AUTH_EXPIRED_EVENT` when a
 * 401 cannot be recovered via refresh. AuthContext clears the session;
 * RequireAuth (layout route) navigates to /login.
 */

export const AUTH_EXPIRED_EVENT = 'mev-shield:auth-expired';

export type AuthExpiredDetail = {
  reason: 'refresh_failed' | 'no_refresh_token' | 'manual';
};

export function dispatchAuthExpired(detail: AuthExpiredDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(AUTH_EXPIRED_EVENT, { detail })
  );
}
